<template>
  <div class="login-page-wrapper" :class="{'bodyfont-unauth': !user}">
      <img src="../assets/mothersday-image-desktop.jpg" alt="" class="showMobile" style="width:100%;" />
      <div class="over-lay text-left">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="main-heading">
              <button type="button" @click="redirect()" class="btn btn-primary main-heading-btn btn-lg showMobile">Give the Gift of TONE</button>
                <social-sharing network-tag="button" v-bind:url="videoURL" v-bind:quote = "'Give the Gift of Knowledge and Empowerment'" v-bind:description = "sharingDescription" v-bind:title = "sharingTitle"  inline-template>
                    <div class="socialicons">
                        <network network="facebook" class="holder"><span class="sr-only">Share via facebook</span>
                            <i aria-hidden="true" class="fa fa-2x fa-facebook cursor"></i>
                        </network>
                        <network network="twitter" class="holder"><span class="sr-only">Share via twitter</span>
                            <i aria-hidden="true" class="fa fa-2x fa-twitter cursor"></i>
                        </network>
                        <network network="linkedin" class="holder"><span class="sr-only">Share via linkedin</span>
                            <i aria-hidden="true" class="fa fa-2x fa-linkedin cursor"></i>
                        </network>
                        <network network="email" class="holder"><span class="sr-only">Share via email</span>
                            <i aria-hidden="true" class="fa fa-2x fa-envelope cursor"></i>
                        </network>
                        
                    </div>
                </social-sharing>

              <ul><li  v-if="dynamic_para_1" v-html="dynamic_para_1">
                  <!--For the woman who has everything but time....-->
              </li><br></ul>
              <h1 v-if="dynamic_para_2" v-html="dynamic_para_2">
                  <!--Give the Gift of TONE.-->
              </h1>
              <ul>
                <li v-if="dynamic_para_3" v-html="dynamic_para_3">
                    <!--Tone is a generous online community where women can learn from experts, exchange actionable advice and be inspired. All in under 5 minutes a day!-->
                </li>
              </ul>
                <button v-if="dynamic_button_1 && dynamic_button_1 !== ' '" type="button" @click="redirect()" class="btn btn-primary main-heading-btn btn-lg hideMobile">{{dynamic_button_1}}</button>
                <!--<button type="button" @click="redirect()" class="btn btn-primary main-heading-btn btn-lg hideMobile">Give the Gift of TONE</button>-->
            </div>
          </div>
            <div class="col-sm-offset-4 col-sm-3 vedioplayerholder showMobile" v-if="currentPlayerID">
                <jwplayer id="showGiftingMobile" :data="currentPlayerID">Loading the player...</jwplayer>
            </div>
        </div>
      </div>
    </div>
    <div class="container text-left">
      <div class="row aboutrow">
        <!--<div class="col-md-12">
          <div class="main-content">
            <h2 class="heading text-center">Gifts</h2>
          </div>
        </div>-->
        <div class="col-sm-6" style="text-align:left">
		  								<div class="gifts row" v-if="giftPlans">
											<div class="col-sm-6" v-for="plan in giftPlans">
												<div class="gift-item">
												<h5><strong>Gift of TONE</strong> <br />
													<small>{{plan.description}}</small>
												</h5>
												<button @click="setPackage(plan)">Buy Now: ${{plan.amountFmt}}</button>
												</div>
											</div>
											<!--<div class="col-sm-6">-->
												<!--<div class="gift-item">-->
												<!--<h5><strong>Gift of TONE</strong> <br />-->
													<!--<small>6 Months</small>-->
												<!--</h5>-->
												<!--<button>Buy Now: $19.99</button>-->
												<!--</div>-->
											<!--</div>-->


                                        </div>
            <div class="clearfix"></div>
            <div class="vedioplayerholder hideMobile" v-if="currentPlayerID2">
                <jwplayer id="showGiftingDesktop" :data="currentPlayerID2">Loading the player...</jwplayer>
            </div>
        </div>
        <div class="col-sm-6">
          <h3 v-if="dynamic_para_4" v-html="dynamic_para_4">
          <!--Enjoy hundreds of bite-sized expert videos on topics like Work, Mind, Body, Money and Life-->
          </h3>
          <h4 v-if="dynamic_para_5" v-html="dynamic_para_5">
              <!--Unlimited access to:-->
          </h4>
		  <ul class="tonepoints">
		  	<li v-if="dynamic_bullet_1" v-html="dynamic_bullet_1">
                <!--Join moderated online chats on topics relevant to you-->
            </li>
		  	<li  v-if="dynamic_bullet_2" v-html="dynamic_bullet_2">
                <!--Participate in Exclusive Live streaming events hosted by our experts-->
            </li>
              <li  v-if="dynamic_bullet_3" v-html="dynamic_bullet_3">
                  <!--Tone is a 'gift' to yourself or someone you care about - we make it easy to make time for you-->
              </li>

		  </ul>
            <p style="text-align: justify;"  v-if="dynamic_para_6" v-html="dynamic_para_6">
                <!--To thank you for giving the gift of TONE, you will receive a copy of TONE Expert Debi Silber's most recent book-->
                <!--<strong>The Unshakable Woman</strong> with purchase of a 12 month gift - only for a limited time.-->
            </p>
            <!--/static/img/debi-book.b3c2ab5.jpeg-->
            <img v-if="dynamic_promotion_img && dynamic_promotion_img.length > 5" style="max-width: 50%;margin: 20px auto;float: none;clear: both;display: block;" :src="dynamic_promotion_img" :alt="dynamic_para_7" :title="dynamic_para_7"/>
            <h4 v-if="dynamic_para_7" v-html="dynamic_para_7">
                <!--Come join us!-->
            </h4>
        </div>
        <div class="clearfix"></div>

      </div>
      <div class="clearfix"></div>

    </div>
  </div>
</template>

<script>
    import spinner from '@/accessibility/Spinner'
    import alert from '@/accessibility/Alert'
    import input from '@/accessibility/Input'
    import { mapGetters } from 'vuex'
    import jwplayer from './JwPlayer.vue'
//    import $ from 'jquery'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert,
            'jwplayer': jwplayer
        },
        name: 'login',
        metaInfo () {
            return {
                title: 'TONE Gifts',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mothersday-image-mobile.jpg'},
                    {property: 'og:title', content: 'Give the Gift of Knowledge and Empowerment | TONE Networks'},
                    {property: 'og:site_name', content: 'The Perfect Holiday Gift for all the Women in Your Life'},
                    {
                        property: 'og:description',
                        content: 'Give the women in your life a subscription to TONE Networks, an empowering female community built around expert advice and support.'
                    },
                    {property: 'twitter:title', content: 'Give the Gift of Knowledge and Empowerment | TONE Networks'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mothersday-image-mobile.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'Give the women in your life a subscription to TONE Networks, an empowering female community built around expert advice and support.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                giftPlans: '',
                spinner: false,
                videoURL: window.location.href,
                currentPlayerID: '',
                currentPlayerID2: '',
                sharingTitle: 'TONE Networks, Set the Tone of Your Life',
                sharingDescription: 'Give the gift of knowledge and inspiration to the women you care about',
                dynamic_para_1: '',
                dynamic_para_2: '',
                dynamic_para_3: '',
                dynamic_para_4: '',
                dynamic_para_5: '',
                dynamic_para_6: '',
                dynamic_para_7: '',
                dynamic_bullet_1: '',
                dynamic_bullet_2: '',
                dynamic_bullet_3: '',
                dynamic_button_1: '',
                dynamic_promotion_img: ''
            }
        },
        computed: {
            ...mapGetters([
                'error', 'getAllPlans', 'getMainVideo', 'user', 'getAllSiteContents'
            ])
        },
        methods: {
            setPackage (plan) {
                window.logEvents('Gifting Page', 'Gifting Page: Plan Selected', `Gifting Page Selected Plan: (${plan.description}) - $${plan.amount}`)
                this.$store.dispatch('SETGIFTID', plan.packageId).then(() => {
                    window.scrollTo(0, 0)
                })
            },
            redirect () {
                window.logEvents('Gifting Page', 'click', `Gifting Page: Give the Gift of Tone (Hero)`)
                this.$router.push(`/sendgift`)
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            }
        },
        mounted: function () {
            this.$store.dispatch('GETDYNAMICCONTENTS', 2).then(() => {
                if (this.getAllSiteContents) {
                    this.dynamic_para_1 = this.setDynamicSection(this.getAllSiteContents, 'PARA_1')
                    this.dynamic_para_2 = this.setDynamicSection(this.getAllSiteContents, 'PARA_2')
                    this.dynamic_para_3 = this.setDynamicSection(this.getAllSiteContents, 'PARA_3')
                    this.dynamic_para_4 = this.setDynamicSection(this.getAllSiteContents, 'PARA_4')
                    this.dynamic_para_5 = this.setDynamicSection(this.getAllSiteContents, 'PARA_5')
                    this.dynamic_para_6 = this.setDynamicSection(this.getAllSiteContents, 'PARA_6')
                    this.dynamic_para_7 = this.setDynamicSection(this.getAllSiteContents, 'PARA_7')
                    this.dynamic_bullet_1 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_1')
                    this.dynamic_bullet_2 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_2')
                    this.dynamic_bullet_3 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_3')
                    this.dynamic_button_1 = this.setDynamicSection(this.getAllSiteContents, 'BUTTON_1')
                    this.dynamic_promotion_img = this.setDynamicSection(this.getAllSiteContents, 'IMAGE_1')
                }
            })
            this.$store.dispatch('GETPLANS').then(() => {
                this.giftPlans = this.getAllPlans.filter(pln => {
                    return (pln.type.toLowerCase().indexOf('gift') >= 0 && pln.packageId > 8)
                })
            })
            this.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(() => {
                if (this.getMainVideo) {
                    this.currentPlayerID = {video: this.getMainVideo.sources[this.getMainVideo.sources.length - 1].file, title: this.getMainVideo.title, img: this.getMainVideo.image, playerID: new Date(), tracks: this.getMainVideo.tracks, isMute: true, showCaptions: true, mediaId: this.getMainVideo.mediaid}
                    this.currentPlayerID2 = {video: this.getMainVideo.sources[this.getMainVideo.sources.length - 1].file, title: this.getMainVideo.title, img: this.getMainVideo.image, playerID: (new Date().getHours() + new Date().getMinutes() + new Date().getSeconds() * Math.floor(Math.random() * 50)), tracks: this.getMainVideo.tracks, isMute: true, showCaptions: true, mediaId: this.getMainVideo.mediaid}
                }
            })
            this.$store.dispatch('CACHEPAGE', window.location.href)
            this.$root.$on('social_shares_open', function (network, url) {
                // console.info('social sharing on: ', network)
                window.logEvents('Gifting Page', 'social share', `Gifting page shared on: ${network}`)
            })
            if (this.user) {
//                window.juapp = window.juapp || function () {
//                    (window.juapp.q = window.juapp.q || []).push(arguments)
//                }
                window.juapp('arb', '[userId]', '[auth]')
            } else {
//                window.juapp = window.juapp || function () {
//                    (window.juapp.q = window.juapp.q || []).push(arguments)
//                }
                window.juapp('arb', '[userId]', '[unauth]')
            }
        }
    }
</script>
<style>
    /*.socialicons i{*/
        /*margin-right:30px;*/
    /*}*/
    /*@media(max-width:767px) {*/
        /*.socialicons i {*/
            /*color: #333;*/
        /*}*/
    /*}*/
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .socialicons {
        color: #f0617d;
        letter-spacing: 10px;
    }
    @media(max-width:767px) {
        .socialicons {
            color: #f0617d;
            margin: 20px 0 0;
        }
    }
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .aboutlogoholder {
        min-height: 300px;
        line-height: 300px;
    }

    .mtop30 {
        margin-top: 30px;
    }

    .row.aboutrow p {
        font-size: 17px;
        text-align: left;
        line-height: 1.3;
        letter-spacing: 2px;
    }
    h3 {
        color: #f0617d;
        letter-spacing: 4px;
        font-size: 24px;
        line-height: 1.5;
        margin: 30px 0 20px;
    }
    h4 {
        color: #454545;
        letter-spacing: 2px;
        font-size: 18px;
        text-align: left;
        line-height: 1.5;
		font-weight:700;
    }
    h4.welcomemessage {
        text-align: center;
        margin: 50px 0 0;
        color: inherit;
        color: #f0617d;
    }

    h2.welcomemessage {
        letter-spacing: 8px;
        margin: 20px 0 60px;
        text-transform: uppercase;
    }
    .slide-player img {
        max-width: 100%;
    }
    @media(max-width:480px){
        body h4 {
            font-size: 18px !important;
        }

        h3 {
            font-size: 24px !important;
            line-height: 1.1 !important;
        }

        h2.welcomemessage {
            letter-spacing: 3px !important;
        }
    }
.over-lay {
    /*background-image: url(https://s3.amazonaws.com/tone-assets/images/TONEGiftingHolidays.jpg);background-repeat: no-repeat;*/
    background-image: url(../assets/mothersday-image-desktop.jpg);background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    width: 100%;
    display: inline-block;
    padding: 50px 0 50px;
}
.over-lay .main-heading p {
    margin-top: 15px;
    font-size: 20px;
    line-height: 31px;
    font-family: "Quicksand", sans-serif;
}
.over-lay ul {
    margin: 30px 0 0;
    padding: 0;
}

.over-lay ul {
    font-size: 27px;
    font-weight: 500;
    line-height: 1.2;
}

.over-lay ul li {
    list-style: none;
    margin: 0 0 0px;
}
    .main-heading .btn {
        margin: 30px 0;
        font-size: 24px;
    }
.showMobile{display:block;}
@media(min-width:768px){
    .showMobile{display:none;}

.over-lay h1 {
    color: #fff;
	clear:both;
}

.over-lay ul li:nth-child(1) {
    clear: left;
    float: left;
    margin-right: 10px;
}
    .over-lay .container {
        max-width: 95%;
        width: 100%;
    }
}

    .over-lay:before {
        z-index:5;
        background-image:url(../assets/whiteribbon.png);
        /*content:"";*/
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: cover !important;
        background-position: left top !important;
    }
.over-lay {
    position: relative;
}

.over-lay .container {
    position: relative;
    z-index: 10;
	color:#fff;
}
ul.tonepoints {
    font-size: 18px;
    letter-spacing: 2px;
}

ul.tonepoints li {
    margin: 0 0 20px;
}
@media (max-width:767px){
    .over-lay.text-left {
        background-image: none;
        padding: 20px 0;
        color: #333 !important;
    }
    .main-heading .btn {
        margin: 10px 0 30px;
        font-size: 24px;
    }
    .over-lay:before , .over-lay:after {
        display: none;
    }

    .over-lay h1 {
        color: #343434;
    }

    .over-lay .main-heading p {
        color: #343434;
    }

    .over-lay ul li {
        color: #343434;
    }

}

    .row.aboutrow {
        padding-bottom: 50px;
    }
/*gift section classes*/
.gift-item:before {
    background: url(../assets/img_33997.png);
	content:"";
    height: 150px;
    display: block;
    /* width: 100%; */
    position: absolute;
    background-position: center !important;
    background-repeat: no-repeat !important;
    transform: translateY(-50%);
    /* margin: 120px 0 0; */
    /* top: -30px; */
    top: 0;
    right: 0;
    left: 0;
}

.gift-item {
    background: #54d9ec;
    color: #fff;
    margin: 120px 0 0;
    padding: 80px 20px 20px;
    position: relative;
    text-align: center;
}

.gift-item h5 {
    font-size: 22px;
    /* font-weight: 100 !important; */
}

.gift-item h5 small {
    color: #fff;
}
.gift-item button {
    background: #0eb4ce;
    border: 2px solid #13a8bf;
    padding: 10px 25px;
    margin: 10px 0;
}
.gifts.row {
    margin-bottom: 50px;
}

    @media(min-width:768px){

    }
    @media(max-width:767px){
        .vedioplayerholder {
            margin-top: 20px;
        }
    }

    /*social icons settings*/


    @media(min-width:768px){
        .socialicons {
            position: absolute;
            right: 30px;
            width: 20px;
            top:calc(100% + 70px);
        }

        .over-lay .col-sm-5 {
            position: static;
        }

        .socialicons > span, .socialicons > button {
            margin: 0 0 20px;
            display: block;
        }



    }
    @media(min-width:992px){
        .socialicons {
            top: calc(100% + 70px);
        }
    }
    @media(min-width:1200px){
        .socialicons {
            top: calc(100% + 70px);
        }
    }
    @media(max-width:767px){
        .hideMobile {
            display: none;
        }
        .over-lay ul{
            font-size:22px;
        }
    }
    @media(min-width:768px) {
        .over-lay ul, .over-lay H1 {
            text-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
        }
    }
</style>
<style>
    .socialicons  > .holder .fa {
        color: #fff;
        line-height: 42px;
        width: 42px;
        text-align: center;
        display: block;
        letter-spacing: 0;
    }

    .socialicons  > .holder {
        background: #f0617d;
        width: 42px;
        display: inline-block;
        height: 42px;
        line-height: 42px;
        border-radius: 50%;
    }
    .socialicons > a img {
        max-width: 42px;
    }
    @media(min-width:768px){
        .socialicons  > .holder {
            margin: 0 0 20px;
            display:block;
        }
        .over-lay .row {
            min-height: 450px;
        }
    }
</style>



// WEBPACK FOOTER //
// Gifts.vue?3a125553